import { API_URL } from '../../../constants';
import _fetch from '../../_fetch';

export default function fetchBlogTags() {
  return function withContext(context) {
    const url = `${API_URL}blog/tags`;
    return _fetch(url, { withAuth: false }, { method: 'GET' })(context);
  };
}
